<template>
  <div class="p-grid">
    <div class="p-col-12 p-d-flex p-justify-end">
      <Button
        class="p-button-success"
        icon="pi pi-save"
        label="บันทึก"
        @click="onSaveDocument"
        :disabled="isReadonly"
      ></Button>
      <Button
        class="p-button-success p-button-danger p-ml-2"
        icon="pi pi-save"
        label="ส่งเอกสารให้พนักงาน"
        @click="onReleaseDocument"
        :disabled="isReadonly"
      ></Button>
      <Button
        class="p-button-warning p-ml-2"
        icon="pi pi-chevron-left"
        label="ย้อนกลับ"
        @click="onBack"
      ></Button>
    </div>
    <div class="p-col-12">
      <Card>
        <template #title=""> ข้อมูลเอกสาร {{ positionDocument.id }} </template>
        <template #subtitle="">
          <Tag severity="warning" v-if="isReadonly === false">บันทึก</Tag>
          <template v-else>
            <Tag severity="success">ส่งให้พนักงานแล้ว</Tag>
            <small>
              โดย {{ positionDocument.releaseById }} เมื่อ
              {{ formatAppDateTime(positionDocument.releaseOn) }}</small
            >
          </template>
        </template>
        <template #content="">
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-md-6 p-fluid p-field">
              <span class="p-float-label">
                <InputUser
                  v-model="positionDocument.employeeId"
                  id="employeeId"
                  :class="{
                    'p-invalid': v$.positionDocument.employeeId.$error,
                  }"
                  :disabled="isReadonly"
                  @change="onSelectEmployee"
                ></InputUser>
                <label for="employeeId">ระบุพนักงาน</label>
              </span>
              <small
                class="p-error"
                v-if="v$.positionDocument.employeeId.$error"
                >{{ v$.positionDocument.employeeId.required.$message }}
              </small>
            </div>
            <div class="p-col-12 p-lg-3 p-md-6 p-fluid p-field">
              <span class="p-float-label">
                <InputUser
                  v-model="positionDocument.supervisorId"
                  id="supervisorId"
                  :class="{
                    'p-invalid': v$.positionDocument.supervisorId.$error,
                  }"
                  :disabled="isReadonly"
                ></InputUser>
                <label for="supervisorId">ระบุหัวหน้างาน</label>
              </span>
              <small
                class="p-error"
                v-if="v$.positionDocument.supervisorId.$error"
                >{{ v$.positionDocument.supervisorId.required.$message }}
              </small>
            </div>
            <div class="p-col-12 p-lg-3 p-md-6 p-fluid p-field">
              <span class="p-float-label">
                <Dropdown
                  id="documentTypes"
                  :options="positionDocumentTypes"
                  optionValue="code"
                  optionLabel="description"
                  v-model="positionDocument.type"
                  :disabled="isReadonly || positionDocument.id !== ''"
                  @change="onSelectDocumentType"
                >
                </Dropdown>
                <label for="documentTypes">ระบุประเภทเอกสาร</label>
              </span>
            </div>
            <div class="p-col-12 p-lg-3 p-md-6 p-fluid p-field">
              <span class="p-float-label">
                <Calendar
                  id="documentDate"
                  v-model="positionDocument.documentDate"
                  :disabled="isReadonly"
                >
                </Calendar>
                <label for="documentDate">ระบุวันที่เอกสาร</label>
              </span>
            </div>
            <div class="p-col-12 p-lg-3 p-md-6 p-fluid p-field">
              <span class="p-float-label">
                <InputQuestion
                  id="question"
                  showClear
                  v-model="positionDocument.questionId"
                  :disabled="isReadonly"
                ></InputQuestion>
                <label for="question">แบบประเมิน </label>
              </span>
              <small
                >สำหรับในกรณีที่ต้องการให้พนักงานมีการทำแบบประเมินเท่านั้น</small
              >
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-col-12">
      <Card>
        <template #title="">
          ข้อมูลเนื้อหาที่ประเมิน
        </template>
        <template #content="">
          <div class="p-grid">
            <div class="p-col-12 p-d-flex p-justify-end">
              <Button
                icon="pi pi-plus"
                label="เพิ่มใหม่"
                @click="onAddItem"
                :disabled="isReadonly"
              ></Button>
            </div>
            <div class="p-col-12">
              <DataTable
                :value="sortedItems"
                class="p-datatable-sm"
                dataKey="sort"
              >
                <template #empty="">ยังไม่ระบุข้อมูล</template>
                <template #footer=""
                  >จำนวนทั้งหมด {{ items.length }} รายการ</template
                >
                <Column header="เรื่องที่ประเมิน">
                  <template #body="props">
                    <div class="p-fluid">
                      <InputCourse
                        v-model="props.data.courseId"
                        :required="isSubmitting"
                        :disabled="isReadonly"
                      ></InputCourse>
                    </div>
                  </template>
                </Column>

                <Column
                  header="การเรียงลำดับ"
                  field="sort"
                  headerStyle="width: 12rem"
                  bodyStyle="width: 12rem"
                >
                  <template #body="props">
                    <div class="p-fluid">
                      <InputNumber
                        v-model="props.data.sort"
                        :disabled="isReadonly"
                      ></InputNumber>
                    </div>
                  </template>
                </Column>
                <Column headerStyle="width: 4rem" bodyStyle="width: 4rem">
                  <template #body="props">
                    <Button
                      class="p-button-danger p-button-rounded"
                      icon="pi pi-minus"
                      @click="onDeleteItem(props.index)"
                      :disabled="isReadonly"
                    ></Button>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  watch,
  computed,
  onMounted,
  nextTick,
} from "vue";
import { usePlugin } from "@/plugins";
import InputUser from "@/components/InputUser.vue";
import InputCourse from "@/components/InputCourse.vue";
import InputQuestion from "@/components/InputQuestion.vue";
import {
  PositionDocument,
  PositionType,
  Employee,
  PositionDocumentItem,
  GetPositionDocumentRequest,
  GetPositionDocumentResponse,
  UpsertPositionDocumentRequest,
  UpsertPositionDocumentResponse,
  positionDocumentTypes,
  GetConfigQuestionSetResponse,
  ConfigQuestionSet,
  CourseRelation,
  GetCourseRelationResponse,
  GetCourseForEmployeeRequest,
  GetCourseForEmployeeResponse,
} from "@/types";
import { clone } from "ramda";
import { useVuelidate } from "@vuelidate/core";
import { required, requiredIf, helpers } from "@vuelidate/validators";

export default defineComponent({
  name: "PositionDocumentCreate",
  components: { InputUser, InputCourse, InputQuestion },
  setup() {
    const {
      onBack,
      dayjs,
      setLoading,
      error,
      success,
      route,
      axios,
      onRouterReplace,
      useState,
      formatAppDateTime,
      confirmation,
    } = usePlugin();

    const initial: PositionDocument = {
      id: "",
      releaseOn: null,
      releaseById: null,
      releaseBy: null,
      dunningDate1: null,
      dunningDate2: null,
      isDunning1: false,
      isDunning2: false,
      superVisorDunningDate1: null,
      superVisorDunningDate2: null,
      isSuperVisorDunning1: false,
      isSuperVisorDunning2: false,
      documentDate: dayjs().toDate(),
      submitOn: null,
      approveOn: null,
      employeeId: null,
      supervisorId: null,
      type: PositionType.NewEmployee,
      questionId: null,
      assessmentData: null,
      supervisorAssessmentData: null,
      employee: null,
      supervisor: null,
      question: null,
      status: "",
      questionData: null,
      supervisorQuestionData: null,
      cancelOn: null,
      cancelById: null,
      cancelBy: null,
      releaseStatus: null,
    };
    const positionDocument = ref<PositionDocument>(initial);
    const questionSets = ref<ConfigQuestionSet[]>([]);

    const items = ref<PositionDocumentItem[]>([]);
    const sortedItems = computed(() => {
      return items.value.sort((x, y) => x.sort - y.sort);
    });
    const id = computed(() => (route.params["id"] as string) ?? "");
    const isCopy = computed(() => route.params["copy"] === "true");
    const isSubmitting = ref(false);

    const rules = computed(() => ({
      positionDocument: {
        documentDate: {
          required: helpers.withMessage("กรุณาระบุวันที่เอกสาร", required),
        },
        employeeId: {
          required: helpers.withMessage(
            "กรุณาระบุรหัสพนักงานที่ประเมิน",
            required
          ),
        },
        supervisorId: {
          required: helpers.withMessage(
            "กรุณาระบุรหัสหัวหน้างาน",
            requiredIf(() => isSubmitting.value)
          ),
        },
      },
    }));
    const v$ = useVuelidate(rules, { positionDocument }, { $lazy: true });

    const onAddItem = () => {
      items.value.push({
        sort: nextItem.value,
        courseId: "",
        courseDescription: "",
        answer: null,
        mandatory: true,
      });
    };

    const nextItem = computed(() => {
      if (items.value.length === 0) return 10;
      return (
        clone(items.value).sort((x, y) => (y.sort ?? 0) - (x.sort ?? 0))[0]
          ?.sort + 10
      );
    });

    const onDeleteItem = (index: number) => {
      items.value.splice(index, 1);
    };

    const loadQuestionSet = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetConfigQuestionSetResponse>(
          "api/v1/services/configQuestionSet",
          {}
        );
        questionSets.value = result.data.configQuestionSets ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const loadDocument = async () => {
      if (!id.value) return;
      setLoading(true);
      try {
        const result = await axios.post<GetPositionDocumentResponse>(
          "api/v1/services/positionDocument/get",
          {
            id: id.value,
          } as GetPositionDocumentRequest
        );

        if ((result.data.positionDocuments?.length ?? 0) > 0) {
          positionDocument.value = result.data.positionDocuments[0];

          if (positionDocument.value.documentDate !== null) {
            positionDocument.value.documentDate = dayjs(
              positionDocument.value.documentDate
            ).toDate();
          }

          items.value = JSON.parse(
            positionDocument.value.assessmentData ?? "[]"
          );
        } else {
          error("ไม่พบเอกสาร");
        }
        success("ดึงข้อมูลเรียบร้อยแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const saveDocument = async () => {
      setLoading(true);
      try {
        positionDocument.value.assessmentData = JSON.stringify(items.value);

        const result = await axios.post<UpsertPositionDocumentResponse>(
          "api/v1/services/positionDocument/upsert",
          {
            positionDocument: positionDocument.value,
          } as UpsertPositionDocumentRequest
        );
        success("บันทึกเอกสารแล้ว");
        positionDocument.value = result.data.positionDocument;
        if (!id.value || isCopy.value === true)
          onRouterReplace({
            name: "editPositionDocument",
            params: { id: positionDocument.value.id! },
          });
        else loadDocument();
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const state = useState();
    const onReleaseDocument = async () => {
      isSubmitting.value = true;
      v$.value.$reset();
      v$.value.$touch();
      if (!(await v$.value.$validate())) return;

      confirmation.require({
        header: "ยืนยันส่งเอกสาร?",
        message: `กรุณายืนยันเพื่อทำการส่งเอกสารให้พนักงานรหัส ${positionDocument.value.employeeId} ${positionDocument.value.employee?.prename}${positionDocument.value.employee?.name} ${positionDocument.value.employee?.surname} ?`,
        acceptLabel: "ยืนยันส่งเอกสาร",
        accept: async () => {
          positionDocument.value.releaseOn = dayjs().toDate();
          positionDocument.value.releaseById =
            state.value.authentication.username;
          await saveDocument();
        },
        rejectLabel: "ยกเลิก",
      });
    };

    const onSaveDocument = async () => {
      isSubmitting.value = false;
      v$.value.$reset();
      v$.value.$touch();
      if (!(await v$.value.$validate())) return;

      await saveDocument();
    };

    const isReadonly = computed(() => {
      return positionDocument.value.releaseOn !== null;
    });

    const onSelectDocumentType = () => {
      const typeEnum = positionDocumentTypes.find(
        (x) => x.code === positionDocument.value.type
      )?.enum;
      const questionSet = questionSets.value.find(
        (x) => x.trainingType === typeEnum
      );
      if (questionSet) {
        positionDocument.value.questionId = questionSet.knowledgeQuestionId;
        success("ทำการ set ค่าคำถามให้อัตโนมัติ จาก configuration แล้ว");
      }
    };

    const onSelectEmployee = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetCourseForEmployeeResponse>(
          "api/v1/services/courseRelation/get",
          {
            employeeId: positionDocument.value.employeeId,
          } as GetCourseForEmployeeRequest
        );

        if (result.data.courseIds && result.data.courseIds.length > 0) {
          if (items.value.length > 0) {
            confirmation.require({
              header: "ข้อมูลการฝึกอบรมจาก Config",
              message:
                "กรุณายืนยันเพื่อทำการทับข้อมูล Course จาก configuration !!! ข้อมูลที่คุณกรอกไว้แล้วจะหายไป",
              acceptLabel: "ยืนยันทับด้วยข้อมูลจาก Config",
              rejectLabel: "ยกเลิก",
              accept: () => {
                items.value = result.data.courseIds!.map(
                  (x, i) =>
                    ({
                      courseId: x,
                      courseDescription: "",
                      mandatory: true,
                      sort: (i + 1) * 10,
                      answer: null,
                    } as PositionDocumentItem)
                );
              },
            });
          } else {
            items.value = result.data.courseIds.map(
              (x, i) =>
                ({
                  courseId: x,
                  courseDescription: "",
                  mandatory: true,
                  sort: (i + 1) * 10,
                  answer: null,
                } as PositionDocumentItem)
            );
          }
        }
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(async () => {
      await loadQuestionSet();
      await loadDocument();
      onSelectDocumentType();
      if (isCopy.value === true) {
        positionDocument.value.id = "";
        positionDocument.value.employeeId = null;
        positionDocument.value.employee = null;
        positionDocument.value.submitOn = null;
        positionDocument.value.releaseOn = null;
        positionDocument.value.releaseById = null;
        positionDocument.value.documentDate = new Date();
        positionDocument.value.dunningDate1 = null;
        positionDocument.value.dunningDate2 = null;
        positionDocument.value.isDunning1 = false;
        positionDocument.value.isDunning2 = false;
        positionDocument.value.superVisorDunningDate1 = null;
        positionDocument.value.superVisorDunningDate2 = null;
        positionDocument.value.isSuperVisorDunning1 = false;
        positionDocument.value.isSuperVisorDunning2 = false;
        positionDocument.value.supervisorId = null;
        positionDocument.value.supervisor = null;

        success("กรุณาบันทึกข้อมูลเพื่อสร้างเอกสารใหม่");
      }
    });

    return {
      onBack,
      positionDocumentTypes,
      positionDocument,
      items,
      sortedItems,
      onAddItem,
      onDeleteItem,
      onSaveDocument,
      onReleaseDocument,
      v$,
      isSubmitting,
      isReadonly,
      formatAppDateTime,
      questionSets,
      onSelectDocumentType,
      onSelectEmployee,
    };
  },
});
</script>

<style></style>
